
// 组件配色色卡
export const COLOR_LIST = [
  {
    value: ['#0276FA', '#3ECB6F', '#F8C73E', '#FF6A00', '#69CDFF', '#42F6A8', '#D1FE68', '#65FFF0', '#F37F7F'],
    name: '默认',
    img: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/color0.svg',
    label: 'default',
    number: 0,
  },
  {
    value: ['#00F8FF', '#FF6D2E', '#3BF28F', '#FFC913', '#8E9FFE', '#15EBCE', '#FF972E', '#D6E92C', '#BFD0FF'],
    name: '未来',
    img: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/color1.svg',
    label: 'iceBlue',
    number: 1,

  },
  {
    value: ['#486CFF', '#FC9000', '#00C3C1', '#FCD800', '#D5DFFF', '#FF7D32', '#87ADFC', '#55E2B2', '#FDFF5E'],
    name: '罗兰',
    img: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/color2.svg',
    label: 'sapphireBlue',
    number: 2,
  },
  {
    value: ['#31F59A', '#7DDE25', '#F5C846', '#30B9EF', '#FFF348', '#B8FF8A', '#FFDE5B', '#B6E1F2', '#FFC933'],
    name: '自然',
    img: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/color3.svg',
    label: 'aurora',
    number: 3,
  },
  {
    value: ['#A6A6F3', '#E5D492', '#BADB6D', '#D47777', '#92C4E5', '#A6F3B8', '#886DD5', '#C56DD5', '#FE75A3'],
    name: '梦幻',
    img: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/color8.svg',
    label: 'magic',
    number: 8,
  },
  {
    value: ['#ADF1FF', '#1BF8C3', '#65C3FF', '#FFDF53', '#FFA145', '#F16C55', '#B8FFEE', '#61A0FF', '#FFF0AC'],
    name: '北极',
    img: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/color9.svg',
    label: 'northPole',
    number: 9,
  },
  {
    value: ['#14F1CD', '#30B9EF', '#F5C846', '#31F59A', '#208FFF', '#B8FF8A', '#FFDE5B', '#B6E1F2', '#FFC1C1'],
    name: '极光',
    img: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/color10.svg',
    label: 'aurora',
    number: 10,
  },
  {
    value: ['#F28705', '#C52104', '#F0C418', '#FF6F00', '#FFE171', '#468966', '#FFB03B', '#B64926', '#8E2800'],
    name: '落日',
    img: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/color5.svg',
    label: 'settingSun',
    number: 5,
  },
  {
    value: ['#CBAC3F', '#B97C38', '#32A88E', '#B8AB7F', '#9AB8D5', '#E2F2FF', '#FF963B', '#5187E5', '#4757A7'],
    name: '鎏金',
    img: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/color11.svg',
    label: 'gold',
    number: 11,
  },

  {
    value: ['#71AE46', '#96B744', '#C4CC38', '#EBE12A', '#EAB026', '#E3852B', '#D85D2A', '#CE3D26', '#C42800'],
    name: '渐变',
    img: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/color4.svg',
    label: 'gradual',
    number: 4,
  },
  {
    value: ['#68BEFF', '#76DA91', '#F8CB7F', '#F89588', '#7CD6CF', '#B1B4EB', '#8BAEFF', '#EFA666', '#EDDD86'],
    name: '简洁',
    img: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/color6.svg',
    label: 'plain',
    number: 6,

  },
  {
    value: ['#FF9F4D', '#FF6D45', '#3BD594', '#BBF071', '#45BFF4', '#9DE0FF', '#B8FF8A', '#F3ED80', '#DCD5D0'],
    name: '柔和',
    img: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/color7.svg',
    label: 'soft',
    number: 7,
  },

]

// colorPick 预定义yanse颜色
export const COLOR_PICKER_LIST = ['#fff', '#0276fa', '#00f8ff', '#01ffb7', '#2424ff', '#90ee90', '#68beff', '#ff9f4d', '#071228']

// 独立数字组件边框样式
export const INDEPENDENT_NUMBER_BORDER_LIST = [
  { label: 'zu33411', value: 1 },
  { label: 'zu34462', value: 2 },
  { label: 'zu34487', value: 3 },
  { label: 'zu34478', value: 4 },
  { label: 'zu34483', value: 5 },
  { label: 'zu34493', value: 6 },
]

// 边框组件边框样式
export const BORDER_TYPE_LIST = [
  { label: 'zu34605', value: 1 },
  { label: 'zu34602', value: 2 },
  { label: 'zu34604', value: 3 },
  { label: 'zu34603', value: 4 },
]

// 高德地图，地图风格
export const AMAP_STYLE_LIST = [
  { label: '标准', value: 'normal' },
  { label: '幻影黑', value: 'dark' },
  { label: '月光银', value: 'light' },
  { label: '远山黛', value: 'whitesmoke' },
  { label: '草色青', value: 'fresh' },
  { label: '雅士灰', value: 'grey' },
  { label: '涂鸦', value: 'graffiti' },
  { label: '马卡龙', value: 'macaron' },
  { label: '靛青蓝', value: 'blue' },
  { label: '极夜蓝', value: 'darkblue' },
  { label: '酱籽', value: 'wine' },
]
